/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Recent_TitleInputs */

const en_directory_home_board_recent_title = /** @type {(inputs: Directory_Home_Board_Recent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh launches`)
};

const zh_directory_home_board_recent_title = /** @type {(inputs: Directory_Home_Board_Recent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新鲜发布`)
};

/**
* | output |
* | --- |
* | "Fresh launches" |
*
* @param {Directory_Home_Board_Recent_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_recent_title = /** @type {((inputs?: Directory_Home_Board_Recent_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Recent_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_recent_title(inputs)
	return zh_directory_home_board_recent_title(inputs)
});
export { directory_home_board_recent_title as "directory.home.board.recent_title" }